"use client";

import type { ReactNode } from "react";
import { useInjectStyles } from "../utils/useInjectStyles";

export type BadgeVariant = "neutral" | "success" | "warning" | "danger" | "info";

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
  /**
   * 是否顯示狀態圓點（實心圓＝成功、空心圓＝中性、方塊＝警告、紅空心＝危險）。
   *
   * 圓點是給**狀態**用的形狀線索，讓色弱使用者不必單靠顏色分辨啟用／停用／待審。
   * 用來表示**分類標籤**（角色名、影片類別、資料夾名這類多值 tag）時請傳 dot={false}
   * ——分類沒有「狀態」可言，掛個圓點只會讓人誤以為那是某種開關，也讓一列裡的
   * 標籤與狀態長得一樣分不出來。info 一律不顯示圓點（它本來就是標籤用的 variant）。
   */
  dot?: boolean;
}

export function Badge({ children, variant = "neutral", className, dot = true }: BadgeProps) {
  useInjectStyles();
  const cls = [
    "cui-reset",
    "cui-badge",
    `cui-badge-${variant}`,
    dot ? "" : "cui-badge-nodot",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return <span className={cls}>{children}</span>;
}
